// js/common/overlay/privacy-bar.js
import { Delegate as Delegate2 } from "//momenterie.com/cdn/shop/t/208/assets/vendor.min.js?v=19330323356122838161721917060";
var PrivacyBar = class extends HTMLElement {
  constructor() {
    super();
    this._delegate = new Delegate2(this);
    window.Shopify.loadFeatures([{
      name: "consent-tracking-api",
      version: "0.1",
      onLoad: this._onConsentLibraryLoaded.bind(this)
    }]);
    if (Shopify.designMode) {
      const section = this.closest(".shopify-section");
      section.addEventListener("shopify:section:select", this.show.bind(this));
      section.addEventListener("shopify:section:deselect", this.hide.bind(this));
    }
  }
  connectedCallback() {
    this._delegate.on("click", '[data-action="accept"]', this._acceptPolicy.bind(this));
    this._delegate.on("click", '[data-action="expand"]', this.expand.bind(this));
    this._delegate.on("click", '[data-action="decline"]', this._declinePolicy.bind(this));
    this._delegate.on("click", '[data-action="close"]', this.hide.bind(this));
    document.addEventListener("privacy-bar:reopen", this.show.bind(this));
  }
  disconnectedCallback() {
    this._delegate.off();
    document.removeEventListener("privacy-bar:reopen", this.show.bind(this));
  }
  show() {
    this.hidden = false;
    document.documentElement.classList.add("lock");
  }
  expand() {
    this.classList.add("privacy-bar--expanded");
  }
  hide() {
    document.documentElement.classList.remove("lock");
    document.dispatchEvent(new Event("privacy-bar:closed"));
    this.hidden = true;
  }
  _onConsentLibraryLoaded() {
    if (window.Shopify.customerPrivacy?.shouldShowGDPRBanner()) {
      const trackingConsent = localStorage.getItem("trackingConsentGranted");
      if (trackingConsent === "true") {
        window.Shopify.customerPrivacy?.setTrackingConsent({
          "analytics": true,
          "marketing": true,
        }, ()=> {});
      } else if (trackingConsent === "false") {
        document.dispatchEvent(new Event("privacy-bar:closed"));
        return
      } else {
        this.show();
        return
      }
    }
    if (window.Shopify.customerPrivacy?.userCanBeTracked()) {
      enableAllTracking();
    }
    document.dispatchEvent(new Event("privacy-bar:closed"));
  }
  _acceptPolicy() {
    window.Shopify.customerPrivacy?.setTrackingConsent({
      "analytics": true,
      "marketing": true,
    }, this.hide.bind(this));
    localStorage.setItem("trackingConsentGranted", true);
    enableAllTracking();
    sessionStorage.removeItem("cartAttributesSaved");
    this._trackDecision("accepted");
  }
  _declinePolicy() {
    window.Shopify.customerPrivacy?.setTrackingConsent({
      "analytics": false,
      "marketing": false,
    }, this.hide.bind(this));
    localStorage.setItem("trackingConsentGranted", false);
    removeAllTracking();
    sessionStorage.removeItem("cartAttributesSaved");
    this._trackDecision("declined");
  }
  _trackDecision(decision) {
    const env = document.querySelector('html').getAttribute('data-env') || 'develop';
    const backendUrl = env === 'prod' ? 'https://backend.heurekaprints.de' : 'https://backend.dev.heurekaprints.de';
    const domain = window.location.hostname;
    fetch(backendUrl + '/cookieDecision/puzzle', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ cookieDecision: decision, domainName: domain }),
    });
  }
};
if (!window.customElements.get("privacy-bar")) {
  window.customElements.define("privacy-bar", PrivacyBar);
}

var LanguageBanner = class extends HTMLElement {
  constructor() {
    super();
    this._delegate = new Delegate2(this);
    
    this._waitForMarketSwitcher();
  }

  _waitForMarketSwitcher() {
    const checkAndShow = () => {
      if (this.displayLanguagePicker()) {
        this.show();
      }
    };

    document.addEventListener('market-switcher:closed', checkAndShow, { once: true });
    document.addEventListener('market-switcher:skipped', checkAndShow, { once: true });
  }
  displayLanguagePicker() {
    const currentMarket = window.GeoUtils?.getCurrentMarket();
    if (currentMarket !== 'eu') {
      return false;
    }  
    const storedLangPref = window.GeoUtils?.getStoredLanguagePreference();
    if (storedLangPref) {
      return false;
    }
    const browserLanguage = navigator.language.substring(0, 2);
    const selectedLanguage = document.documentElement.lang.substring(0, 2);
    return selectedLanguage === "de" && browserLanguage !== selectedLanguage;
  }
  connectedCallback() {
    this._delegate.on("click", '[data-action="select_lang"]', this.selectLanguage.bind(this));
  }
  disconnectedCallback() {
    this._delegate.off();
  }
  show() {
    this.hidden = false;
    document.documentElement.classList.add("lock");
  }
  hide() {
    document.documentElement.classList.remove("lock");
    document.dispatchEvent(new Event("language-banner:closed"));
    this.hidden = true;
  }
  selectLanguage(event) {
    const button = event.target.closest('[data-action="select_lang"]');
    const lang = button?.dataset.lang;
    
    if (!lang) {
      const error = new Error('Language button missing data-lang attribute');
      console.error(error);
      if (window.Sentry) {
        Sentry.captureException(error);
      }
      return;
    }
    
    window.GeoUtils.setLanguagePreference(lang);
    
    const currentLang = document.documentElement.lang.substring(0, 2);
    
    if (lang === currentLang) {
      this.hide();
      return;
    }
    const query = window.location.search
    const path = window.location.pathname
    const langPrefix = lang === 'de' ? '' : `/${lang}`;
    window.location.replace(`${langPrefix}${path}${query}`);
    this.hide()
  }
};
if (!window.customElements.get("language-banner")) {
  window.customElements.define("language-banner", LanguageBanner);
}

var MarketSwitcher = class extends HTMLElement {
  constructor() {
    super();
    this._delegate = new Delegate2(this);
    this._init();
  }

  async _init() {
    // Wait for GeoUtils to be available
    while (!window.GeoUtils) {
      await new Promise(resolve => setTimeout(resolve, 50));
    }
  
    const shouldShow = await this._shouldShowModal();
    
    if (shouldShow) {
      this.show();
    } else {
      document.dispatchEvent(new Event('market-switcher:skipped'));
    }
  }
  
  async _shouldShowModal() {
    const hasChosenMarket = localStorage.getItem('hasChosenMarket');
    if (hasChosenMarket) {
      return false;
    }
  
    const detectedCountry = await window.GeoUtils.getDetectedCountry();
    if (!detectedCountry) {
      return false;
    }
  
    const ipMarket = window.GeoUtils.getMarketFromCountry(detectedCountry);
    const currentMarket = window.GeoUtils.getCurrentMarket();
  
    return ipMarket !== currentMarket;
  }

  connectedCallback() {
    this._delegate.on('click', '[data-action="select_market"]', this._selectMarket.bind(this));
  }

  disconnectedCallback() {
    this._delegate.off();
  }

  show() {
    this.hidden = false;
    document.documentElement.classList.add('lock');
    document.dispatchEvent(new Event('market-switcher:shown'));
  }

  hide() {
    document.documentElement.classList.remove('lock');
    document.dispatchEvent(new Event('market-switcher:closed'));
    this.hidden = true;
  }

  _selectMarket(event) {
    const button = event.target.closest('[data-action="select_market"]');
    const selectedMarket = button?.dataset.market;

    if (!selectedMarket) {
      const error = new Error('Market button missing data-market attribute');
      console.error(error);
      if (window.Sentry) {
        Sentry.captureException(error);
      }
      return;
    }

    window.GeoUtils.setMarketPreference(selectedMarket);

    const currentMarket = window.GeoUtils.getCurrentMarket();

    if (selectedMarket === currentMarket) {
      if (currentMarket === 'eu') {
        const browserLang = navigator.language.substring(0, 2);
        const currentLang = document.documentElement.lang.substring(0, 2);
        const supportedLangs = ['fr', 'it', 'nl', 'de'];
        
        if (supportedLangs.includes(browserLang) && browserLang !== currentLang) {
          const currentPath = window.location.pathname;
          const currentQuery = window.location.search;
          const langPrefix = browserLang === 'de' ? '' : `/${browserLang}`;
          window.GeoUtils.setLanguagePreference(browserLang);
          localStorage.setItem('hasChosenMarket', 'true');
          window.location.href = `${langPrefix}${currentPath}${currentQuery}`;
          return;
        }
      }
      localStorage.setItem('hasChosenMarket', 'true'); 
      this.hide();
      return;
    }

    this._redirectToMarket(selectedMarket);
  }

  _redirectToMarket(selectedMarket) {
    const currentQuery = window.location.search;
    localStorage.setItem('hasChosenMarket', 'true');

    let targetUrl;
    if (selectedMarket === 'us') {
      targetUrl = `https://us.momenterie.com${currentQuery}`;
    } else {
      const browserLang = navigator.language.substring(0, 2);
      const langPath = ['fr', 'it', 'nl'].includes(browserLang) ? `/${browserLang}` : '';
      targetUrl = `https://momenterie.com${langPath}${currentQuery}`;
    }

    window.location.href = targetUrl;
  }
};

if (!window.customElements.get('market-switcher')) {
  window.customElements.define('market-switcher', MarketSwitcher);
}

export {
  PrivacyBar,
  LanguageBanner,
  MarketSwitcher
};